import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";
import { SEO_POINTS } from "@/data/site";
import { SectionHead, FadeUp } from "@/components/site/Reveal";

export const SeoSection = () => (
  <section id="seo" className="relative py-24 md:py-36 overflow-hidden" data-testid="seo-section">
    <div className="glow-orb w-[520px] h-[520px] bg-blue-600/12 top-10 -right-56" />
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-14 items-start">
        <div className="lg:sticky lg:top-32">
          <SectionHead
            label="Référencement naturel"
            title={
              <>
                Une base solide pour être <span className="text-gradient">visible sur Google.</span>
              </>
            }
            subtitle="Chaque site que nous créons est construit avec une structure pensée pour le référencement naturel dès le premier jour. Le SEO prend du temps — mais votre site part avec toutes les bonnes fondations."
          />
          <FadeUp delay={0.2}>
            <div className="glass rounded-2xl p-6 max-w-md">
              <p className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[var(--accent-cyan)] mb-3">
                Notre engagement
              </p>
              <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
                Dites-nous sur quels mots-clés vous voulez être trouvé : nous construisons la structure et le contenu
                autour. Aucune promesse de première place garantie — juste un travail sérieux et mesurable.
              </p>
              <Link
                to="/creation-site-internet"
                className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-[var(--accent-cyan)] hover:underline"
                data-testid="seo-pillar-link"
              >
                Tout savoir sur la création de site internet <ArrowUpRight size={13} />
              </Link>
            </div>
          </FadeUp>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {SEO_POINTS.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Star;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="card-surface rounded-2xl p-6 md:p-7"
                data-testid={`seo-point-${i}`}
              >
                <Icon size={20} className="text-[var(--accent-violet)] mb-4" />
                <h3 className="font-display font-bold text-lg tracking-tight">{p.title}</h3>
                <p className="text-[var(--text-secondary)] text-sm mt-2 leading-relaxed">{p.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default SeoSection;
